import { createSlice } from "@reduxjs/toolkit"

export const WithdrawSlice = createSlice({
    name: "withdraw",
    initialState: {
        withdrawList: [],
        withdrawAcceptList: [],
        singleDetail: {},
        isFreshData: false,
        isAcceptedFreshData: false,
        totalEntryAccepted: 0,
    },
    reducers: {
        setwithdrawList: (state, action) => {
            state.withdrawList = action.payload
        },
        setwithdrawAcceptList: (state, action) => {
            state.withdrawAcceptList = action.payload
        },
        setFreshList: (state, action) => {
            state.isFreshData = action.payload
        },
        setAcceptedFreshList: (state, action) => {
            state.isAcceptedFreshData = action.payload
        },
        setTotalEntry: (state, action) => {
            state.totalEntry = action.payload
        },
        setTotalEntryAccepted: (state, action) => {
            state.totalEntryAccepted = action.payload
        },
        setSingleData: (state, action) => {
            state.singleDetail = action.payload
        }
    }
})

export const {
    setwithdrawList,
    setwithdrawAcceptList,
    setFreshList,
    setAcceptedFreshList,
    setSingleData,
    setTotalEntry,
    setTotalEntryAccepted
} = WithdrawSlice.actions

export const selectwithdrawList = (state) => state.withdraw.withdrawList
export const selectwithdrawAcceptList = (state) => state.withdraw.withdrawAcceptList
export const selectFreshList = (state) => state.withdraw.isFreshData
export const selectAcceptedFreshList = (state) => state.withdraw.isAcceptedFreshData
export const selectTotalEntry = (state) => state.withdraw.totalEntry
export const selectTotalEntryAccepted = (state) => state.withdraw.totalEntryAccepted
export const selectSingleDetail = (state) => state.withdraw.singleDetail

export default WithdrawSlice.reducer
